export default "__VITE_ASSET__DT$kZfHm__"